import React from "react";
import About from "../../components/about/About";

function index() {
  return (
    <>
      <About />
    </>
  );
}

export default index;
